import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { TelemetryItem, TripItem } from 'src/app/model';
import { ChartAttributes } from 'src/app/model/shared/components/entities/entities-profile/chart-builder';
import { DerivedAlerts } from 'src/app/model/shared/components/entities/entities-profile/entities-widgets-collection/geo-playback';
import { WidgetsServiceService } from 'src/app/modules/home/widgets-collection/widgets-service.service';
import { DataService, ServicecallService, GeneralService, LoaderHandlerService } from 'src/app/services';
import { EntitiesServiceService } from 'src/app/shared/services';
import { HttpClient } from '@angular/common/http';
import { decode } from '@here/flexpolyline';

interface ToggleItem {
  key: string;
  label: string;
  enabled: boolean;
  disabled: boolean;
  isParent: boolean;
  children?: ToggleItem[];
}

interface PopoverAttributeDetail {
  coordinates: [number, number];
  sourceTimestamp: string;
  enhancedMap: {
    segmentId: string;
    speedLimitInKmph: string;
    weatherData: any | null;
    trafficData: any | null;
    trafficSignData: any | null;
  };
  telemetry: any;
}

interface MasterDataOutput {
  telemetry: PopoverAttributeDetail[];
}

interface TransformedData {
  sourceTimestamp: string;
  telemetry: any;
  enhancedMap: {
    segmentId: string;
    mappedCoordinates: {
      latitude: number;
      longitude: number;
    };
    speedLimitInKmph: string;
    weatherData?: any;
    trafficData?: any;
    trafficSignData?: any;
  };
}

interface RawEvent {
  alertName: string;
  coordinatesArray: {
    coordinates: [number, number]; // [lat, lng]
    speed?: number;
    speedLimit?: number;
  }[];
  icon?: string;
}

interface MapEvent {
  lat: number;
  lng: number;
  ts: number; // optional timestamp, can be current time if not available
  type?: string;
  label?: string;
  icon?: string;
  alertName?: string;
  speed: number;
  speedLimit?: number;
}

@Component({
  selector: 'app-geo-trace-playback-v2',
  templateUrl: './geo-trace-playback-v2.component.html',
  styleUrl: './geo-trace-playback-v2.component.css'
})
export class GeoTracePlaybackV2Component {

  chartType = new FormControl();
  entityId = this._router?.url?.split('/')?.[3];
  selectedDate: { tripId: string, start: string, end: string } | Date = null;
  masterMapData: any = [];
  chartSelectedDate: Date[];
  entityDetails: any;
  isloader: boolean = false;
  aggregateDate: { from: Date, to: Date };
  summaryData: any;
  showAiAssist: boolean = false;
  tripAssistPlots: [number, number][];
  selectedTripDetails: { coordinate: [number, number], time: string };
  includeAttributes: boolean = true;
  optimizedRouteData: any;
  optimizedRouteSummary: any;
  mapControlsList: ToggleItem[] = [];
  analyticsForm: FormGroup;
  subscriptions: Subscription[] = [];
  isMapAnalyticsEnabled: boolean = false;
  segmentDetails: any
  selectedAlertIndex: number;
  highlightedSegment : {highlightedTripPoint : {lat: number, lng: number}};

  //Data player
  index: number = 0;
  playbackSpeed: number = 1000;
  duration = 0;
  currentTime = 0;
  totalSteps: number = 0;
  isPaused: boolean = false;
  tripId: string;
  mapControlsForm!: FormGroup;
  hereMappedCoordinatesArray: any;
  telemetryCoordinatesArray: any;
  alertData: any[] = [];
  alertsHighlighted: any[] = [];
  isRunning = false;
  transformedAttributeData: any;
  pager: any = {};
  totalPages: number[];
  geotraceDetails: any;
  isAnalysisDrawerOpen: boolean = false;
  isPlaying: boolean = false;
  telemetryEventsEnabled: boolean = true;

  //Here API Key
  apiKey: string = '';
  hereMapStyleUrl: string;

  //Subscription
  private _activeEntityDetailsSubscription: Subscription;
  private _getTripDetailsSubscription: Subscription;
  private _alertListSubscription: Subscription;
  private _paramSubscription: Subscription;
  private _getEntityDetailsSubscription: Subscription;
  private _routeMapSubscription: Subscription;
  private intervalSubscription!: Subscription;
  private _dataServiceSubscription: Subscription;

  private _tenantConfig: any;
  private _categoryTenantConfig: any;
  private _entitiesMarkerList: any = [];

  public telemetryTableData = [];
  public alertTypes: { key: string, displayName: string }[] = [
    { key: 'start', displayName: 'Start' },
    { key: 'stop', displayName: 'Stop' },
    { key: 'clutch', displayName: 'Clutch' },
    { key: 'brake', displayName: 'Brake' },
    { key: 'harshBrake', displayName: 'Harsh Brake' },
    { key: 'gearShifting', displayName: 'Gear Shifting' }
  ];
  public derivedAlerts: DerivedAlerts = { start: false, stop: false, clutch: false, brake: false, harshBrake: false, gearShifting: false };
  public tripName: string;
  public isCollapsed: boolean = false;
  public chartAttributes: {
    chartAttributes: ChartAttributes, selectedDates: {
      from: Date,
      to: Date,
    },
    order?: number
  };
  public chartTypes = [];
  isResumed: boolean;
  trafficSignals: [number, number][];
  mapEvents: any;
  tunnelBridgeData: any = [];
  telemetryAlertCoordinates: [number, number][];

  constructor(private _router: Router, private _dataSer: DataService, public sharedService: ServicecallService, private http: HttpClient, private fb: FormBuilder,
    private _generalService: GeneralService, private _service: EntitiesServiceService,
    private _datePipe: DatePipe, private _widgetService: WidgetsServiceService, private changeDetectorRef: ChangeDetectorRef, private loaderHandler: LoaderHandlerService, private _Activatedroute: ActivatedRoute,) {
    this._dataServiceSubscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'apiRefresh' || res.name === 'siteChanged') {
        this.getTelemetryCoordinates();
        this._getAlertData();
      }
    });
    this.analyticsForm = this.fb.group({});
  }

  ngOnInit(): any {
    this.mapControlsList = this.sharedService?.getConfiguration('playbackV2MapControlsList')?.mapControlsList ?? [];
    this.apiKey = this.sharedService.getConfiguration('tenantGenericConfig')?.hereApiKey || '';
    this.hereMapStyleUrl = this.sharedService.getConfiguration('tenantGenericConfig')?.hereMapStyleUrl || '';
    // this.getGeoHistory();
    this._getEntitiesDetails();
    this._paramSubscription = this._Activatedroute.queryParams
      .subscribe(params => {
        if (params['selectedDate']) {
          this.selectedDate = this.sharedService?.getConfiguration('tenantGenericConfig')?.tripHistoryProfilingBasedOn === 'tripId' ? (params['selectedDate'] ? JSON.parse(params['selectedDate']) : null) : new Date(params['selectedDate']);
        }
        if (params['from'] && params['to']) {
          this.aggregateDate = { from: new Date(params['from']), to: new Date(params['to']) }
        }
        if (params['tripName']) {
          this.tripName = params['tripName'];
        }
        if (params['tripId']) {
          this.tripId = params['tripId'];
        }
      })
    this.loaderHandler.toggleLoader(1);
    this.totalSteps = this.masterMapData?.[0]?.polygonData?.length || 0;
    this._entitiesMarkerList = this.sharedService.getConfiguration('trackerEntities') ? this.sharedService.getConfiguration('trackerEntities')['trackerEntitiesList'] : [];
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;
    this.getTelemetryCoordinates();
    this._getTripDetails();
    this._setMapControlsForm();
  }

  /**
   * Sets map controls form
   */
  private _setMapControlsForm() {
    this.mapControlsList?.forEach(parent => {
      const parentControl = new FormControl(parent?.enabled);
      this.analyticsForm?.addControl(parent?.key, parentControl);
      if (parent?.disabled) {
        parentControl?.disable({ emitEvent: false });
      }
      if (parent?.isParent && parent?.children) {
        parent?.children?.forEach(child => {
          const childControl = new FormControl(child.enabled);
          this.analyticsForm?.addControl(child?.key, childControl);
          if (child?.disabled) {
            childControl?.disable({ emitEvent: false });
          }
          if (!parent?.enabled) {
            this.analyticsForm?.get(child?.key)?.disable({ emitEvent: false });
          }
        });
      }
      const listenedParentControl = this.analyticsForm?.get(parent.key);
      if (listenedParentControl && parent?.children) {
        const sub = listenedParentControl?.valueChanges?.subscribe(isEnabled => {
          this.handleParentToggle(parent?.key, isEnabled, parent?.children!);
        });
        this.subscriptions?.push(sub);
      }
    });
  }

  /**
   * Handles parent toggle
   * @param parentKey 
   * @param isEnabled 
   * @param children 
   */
  handleParentToggle(parentKey: string, isEnabled: boolean, children: ToggleItem[]): void {
    if (parentKey === 'mapAnalytics') {
      !this.isPlaying ? this.updatePlayback({ index: 0 }) : this.updatePlayback({ index: this.index });
    }
    this.updateListState(parentKey, isEnabled);
    children.forEach(child => {
      const childControl = this.analyticsForm.get(child.key);
      if (childControl) {
        if (isEnabled) {
          childControl.enable();
          if (child?.disabled) {
            childControl?.disable({ emitEvent: false });
          }
          this.updateListState(child.key, childControl.value);
        } else {
          childControl.disable();
          this.updateListState(child.key, false);
        }
      }
    });
    this.performAction(parentKey, isEnabled);
  }

  switchAnalysisDrawer(openFlag: boolean) {
    this.isAnalysisDrawerOpen = openFlag;
  }

  /**
   * Updates list state
   * @param key 
   * @param isEnabled 
   * @returns list state 
   */
  updateListState(key: string, isEnabled: boolean): void {
    for (const parent of this.mapControlsList) {
      if (parent.key === key) {
        parent.enabled = isEnabled;
        return;
      }

      if (parent.children) {
        const child = parent.children.find(c => c.key === key);
        if (child) {
          child.enabled = isEnabled;
          return;
        }
      }
    }
  }

  /**
   * Performs action
   * @param key 
   * @param isEnabled 
   */
  performAction(key: string, isEnabled: boolean): void {
    if (key === 'mapAnalytics') {
      this.isMapAnalyticsEnabled = isEnabled;
      this.resetMapAnalyticsChildrenToDefaults();
    }

    const mapAnalyticsEnabled = this.analyticsForm.get('mapAnalytics')?.value;
    const attributesEnabled = this.analyticsForm.get('attributes')?.value;
    const mapEventsEnabled = this.analyticsForm.get('mapEvents')?.value;

    // Rebuild masterMapData depending on what is enabled
    this.masterMapData = [];

    if (mapAnalyticsEnabled) {
      this.telemetryAlertCoordinates = [];
      this.masterMapData.push({
        polygonData: this.hereMappedCoordinatesArray,
        currentCoordinate: this.hereMappedCoordinatesArray?.[0],
        upcomingCoordinate: this.hereMappedCoordinatesArray?.[1],
        trafficSignals: attributesEnabled ? this._setTrafficSignalCoodinatesArray() : [],
        mapAnalyticsEventsDetails: mapEventsEnabled ? this._setMapAnalyticsEventsDetails() : [],
        attributesDetails: attributesEnabled ? this._setAttributesDetails() : [],
        mapAnalytics: true
      });

      //Traffic signals, Tunnels & Bridges
      if (key === 'attributes') {
        if (isEnabled) {
          this.trafficSignals = this._setTrafficSignalCoodinatesArray();
          this.setTunnelBridgeData();
        } else {
          this.trafficSignals = [];
          this.tunnelBridgeData = [];
        }
      }

      // Optimized route
      if (key === 'routeComparison') {
        if (isEnabled) this.getOptimizedRouteMap();
        else this.optimizedRouteData = [];
      }

      // Map events
      if (key === 'mapEvents') {
        this.mapEvents = isEnabled ? [...this.transformMapEvents(this._setMapAnalyticsEventsDetails())] : [];
      }
    } else {
      if (key === 'telemetryEvents') {
        isEnabled ? this.telemetryEventsEnabled = true : this.telemetryEventsEnabled = false;
      }
      if (this.telemetryEventsEnabled) this.telemetryAlertCoordinates = this._fetchAlertCoordinates();
      else this.telemetryAlertCoordinates = [];
      this.trafficSignals = [];
      this.optimizedRouteData = [];
      this.mapEvents = [];
      this.tunnelBridgeData = [];
      // Attributes without mapAnalytics
      this.masterMapData.push({
        polygonData: this.telemetryCoordinatesArray,
        currentCoordinate: this.telemetryCoordinatesArray?.[0],
        upcomingCoordinate: this.telemetryCoordinatesArray?.[1],
        trafficSignals: this._setTrafficSignalCoodinatesArray(),
        attributesDetails: this._setAttributesDetails()
      });
    }
    this.selectedAlertIndex = -1;

    // Update control list
    this.updateListState(key, isEnabled);
  }

  private resetMapAnalyticsChildrenToDefaults(): void {

    const parent = this.mapControlsList?.find(p => p.key === 'mapAnalytics');
    if (!parent || !parent.children) return;

    parent?.children?.forEach(child => {

      if (child.key === 'fitToRoad') {
        child.enabled = true;
        this.analyticsForm?.get(child.key)?.setValue(true, { emitEvent: false });
        return;
      }

      if (child.disabled) return;

      this.analyticsForm
        ?.get(child.key)
        ?.setValue(child.enabled, { emitEvent: false });
    });
  }

  /**
   * Determines whether chart type change on
   * @param event 
   */
  onChartTypeChange(event) {
    // this._dataSer.broadcast('plotChart', {
    //   chartAttributes: this.chartType?.value, selectedDates: {
    //     from: this.chartSelectedDate?.[0],
    //     to: this.chartSelectedDate?.[1]
    //   }
    // });
    this.chartAttributes = {
      chartAttributes: this.chartType?.value, selectedDates: {
        from: this.chartSelectedDate?.[0],
        to: this.chartSelectedDate?.[1]
      }
    }
  }

  /**
   * Handles back
   */
  handleBack() {
    this._router.navigateByUrl(`/vehicles/profile/${this._router?.url?.split('/')?.[3]}/trip-history`);
  }

  ngOnDestroy(): any {
    this._activeEntityDetailsSubscription?.unsubscribe();
    this._getTripDetailsSubscription?.unsubscribe();
    this._alertListSubscription?.unsubscribe();
    this._paramSubscription?.unsubscribe();
    this._getEntityDetailsSubscription?.unsubscribe();
    this._dataServiceSubscription?.unsubscribe();
    this._routeMapSubscription?.unsubscribe();
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.loaderHandler.disableManualLoader();
  }

  /**
   * Updates ai assist details
   * @param details 
   */
  updateAiAssistDetails(details: any) {
    this.showAiAssist = details?.aiAssist;
    this.tripAssistPlots = details?.tripAssistPlots;
  }

  highlightedTripSegment(details : any) {
    this.highlightedSegment = details?.highlightedTripPoint ?? null;
  }

  /**
   * Expands map
   */
  public expandMap() {
    this.isCollapsed = !this.isCollapsed;
  }

  /**
   * Starts interval
   * @returns interval 
   */
  startInterval(): void {
    this.index = this.index || 0; // Maintain index when resuming

    const mapObject = this.masterMapData?.[0];
    if (!mapObject || !mapObject.polygonData?.length) return;
    if (!this.transformedAttributeData?.length) return;

    this.totalSteps = mapObject.polygonData.length; // Ensure slider has correct max value

    this.intervalSubscription = interval(this.playbackSpeed)?.subscribe({
      // next: () => this.updatePlayback(),
      complete: () => console.log("Interval completed."),
    });

  }

  /**
   * Updates playback
   * @returns playback 
   */
  updatePlayback(event?: any): void {
    this.index = event?.index;
    this.derivedAlerts = { start: false, stop: false, clutch: false, brake: false, harshBrake: false, gearShifting: false };
    const mapObject = this.masterMapData?.[0];
    if (!mapObject) return;

    // Update UI elements
    // this.index = Math.min(this.index, this.totalSteps - 1);
    const prevItem = this.index > 0 ? this.transformedAttributeData[this.index - 1] : {};
    const currentItem = { ...this.transformedAttributeData[this.index], current: true };
    const nextItem = this.index + 1 < this.transformedAttributeData.length ? this.transformedAttributeData[this.index + 1] : {};

    if (currentItem?.['altbs6.PacketType']) {
      const packetType = currentItem['altbs6.PacketType'];
      this.derivedAlerts.start = packetType === 'IN';
      this.derivedAlerts.stop = packetType === 'IF';
      this.derivedAlerts.harshBrake = packetType === 'HB';
    }

    this.derivedAlerts.clutch = Boolean(currentItem?.['can2bs6.ClutchSwitch']);
    this.derivedAlerts.brake = Boolean(currentItem?.['can2bs6.BrakeSwitch']);

    this.derivedAlerts.gearShifting =
      currentItem?.['can2bs6.TransmissionCurrentGear'] !==
      prevItem?.['can2bs6.TransmissionCurrentGear'];

    this.alertData = this.alertData?.map((item) => ({
      ...item,
      current: item?.originalTime === currentItem?.sourceTimestamp,
    }));

    const currentAlertIndex = this.alertData?.findIndex(item => item.current);
    const prevAlert = this.alertData?.[this.alertData?.findIndex(item => item.current) - 1] ?? {};
    const currentAlert = this.alertData?.[this.alertData?.findIndex(item => item.current)];
    const nextAlert = this.alertData?.[this.alertData?.findIndex(item => item.current) + 1] ?? {};

    if (currentAlertIndex !== -1) {
      this.alertsHighlighted = [prevAlert, currentAlert, nextAlert];
    } else {
      this.alertsHighlighted = [...this.alertData];
    }

    this.masterMapData = [{
      ...mapObject,
      alertCoordinate: currentAlert ? [currentAlert?.latitude, currentAlert?.longitude] : null, alertSeverity: currentAlert ? this.getSeverityColor(currentAlert?.severity) : null
    }];
    this.telemetryTableData = [prevItem, currentItem, nextItem];
    this.changeDetectorRef?.detectChanges();
    this.selectedAlertIndex = -1;
  }

  /**
   * Formats time
   * @param stepIndex 
   * @returns time 
   */
  formatTime(stepIndex: number): string {
    const elapsedMs = stepIndex * this.playbackSpeed; // Convert steps to milliseconds
    const totalSeconds = Math.floor(elapsedMs / 1000); // Convert to seconds
    const min = Math.floor(totalSeconds / 60);
    const sec = totalSeconds % 60;
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
  }

  /**
   * Selected alert
   * @param alert 
   */
  selectedAlert(alert: any) {
    this.index = this.transformedAttributeData?.findIndex(data => data.sourceTimestamp === alert?.originalTime);
    this.selectedAlertIndex = this.index;
    this.updatePlayback({ index: this.index });
  }

  /**
   * Gets severity color
   * @param severity 
   * @returns  
   */
  getSeverityColor(severity: string) {
    if (severity === 'major') {
      return '#fccc70';
    } else if (severity === 'minor') {
      return '#c2d0df';
    } else if (severity === 'critical') {
      return '#dd1a31';
    } else {
      return null;
    }
  }

  /**
   * Gets optimized route map
   */
  getOptimizedRouteMap() {
    let startTime = this._datePipe.transform(this.transformedAttributeData?.[0]?.sourceTimestamp, "yyyy-MM-dd'T'HH:mm:ssZ")
      ?.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");
    let originCoord = this.masterMapData?.[0]?.polygonData[0];
    let destCoord = this.masterMapData?.[0]?.polygonData[this.masterMapData?.[0]?.polygonData?.length - 1];
    const requestData = {
      originCoordinates: {
        lat: originCoord?.lat,
        lng: originCoord?.lng
      },
      destinationCoordinates: {
        lat: destCoord?.lat,
        lng: destCoord?.lng
      },
      startTime: startTime,
      transportMode: this.entityDetails?.secondaryDetails?.vehicleClass ?? 'car',
      returns: this._tenantConfig?.playbackV2OptimizedRoutePayloadDetails?.returns,
      routingMode: this._tenantConfig?.playbackV2OptimizedRoutePayloadDetails?.routingMode
    }
    this._routeMapSubscription = this.sharedService?.getRouteMap(requestData)
      .subscribe({
        next: (result: any) => {
          const decoded = decode(result?.route);
          const coordinates = decoded?.polyline?.map(([lat, lng]) => ({ lat, lng }));
          this.optimizedRouteData = { coordinates, travelSummary: result?.travelSummary };
        }, error: (error) => {
          if (error) {
            this.optimizedRouteData = [];
          }
        }
      });
  }

  /**
   * Sets attributes details
   * @returns attributes details 
   */
  private _setAttributesDetails(): PopoverAttributeDetail[] {
    const attributesDetails: PopoverAttributeDetail[] = [];
    if (!this.transformedAttributeData || !Array.isArray(this.transformedAttributeData)) {
      return [];
    }
    const data: TransformedData[] = this.transformedAttributeData as TransformedData[];
    for (const item of data) {
      const enhancedMap = item.enhancedMap;
      if (!enhancedMap || !enhancedMap.mappedCoordinates || !item.telemetry) {
        continue;
      }
      const mappedCoords = enhancedMap.mappedCoordinates;
      const detail: PopoverAttributeDetail = {
        coordinates: [mappedCoords.latitude, mappedCoords.longitude],
        sourceTimestamp: item.sourceTimestamp,
        telemetry: item.telemetry,
        enhancedMap: {
          segmentId: enhancedMap.segmentId,
          speedLimitInKmph: enhancedMap.speedLimitInKmph,
          weatherData: enhancedMap.weatherData || null,
          trafficData: enhancedMap.trafficData || null,
          trafficSignData: enhancedMap.trafficSignData || null
        }
      };
      attributesDetails.push(detail);
    }
    return attributesDetails;
  }

  private _fetchAlertCoordinates() {
    const result = this.alertData?.reduce((acc, alert) => {
      const alertTs = new Date(alert?.originalTime)?.getTime();
      const match = this.transformedAttributeData?.find(attr =>
        new Date(attr?.sourceTimestamp)?.getTime() === alertTs
      );
      if (match) {
        acc?.push({
          lat: match.lat,
          lng: match.long,
          ts: new Date(match.sourceTimestamp)?.getTime()
        });
      }

      return acc;
    }, []);
    return result;
  }

  /**
   * Sets map analytics events details
   * @returns  
   */
  private _setMapAnalyticsEventsDetails() {
    const uniqueSegments = new Map<string, boolean>();
    const overspeedCoordinates = [];
    if (!this.transformedAttributeData || !Array.isArray(this.transformedAttributeData)) {
      return [];
    }
    const data = this.transformedAttributeData;
    for (const item of data) {
      const enhancedMap = item?.enhancedMap;
      const telemetry = item?.telemetry;
      if (!enhancedMap || !item?.speed) {
        continue;
      }
      const segmentId = enhancedMap?.segmentId;
      const vehicleSpeed = Number(item?.speed);
      const speedLimit = Number(enhancedMap?.speedLimitInKmph);
      const isOverspeeding = vehicleSpeed > speedLimit;
      if (isOverspeeding && segmentId && !uniqueSegments.has(segmentId) && speedLimit) {
        uniqueSegments.set(segmentId, true);
        const coords = enhancedMap?.mappedCoordinates;
        if (coords) {
          overspeedCoordinates?.push({
            coordinates: [coords?.latitude, coords?.longitude],
            speed: vehicleSpeed,
            speedLimit: speedLimit
          });
        }
      }
    }
    return [
      {
        alertName: 'Overspeed',
        coordinatesArray: overspeedCoordinates,
        icon: 'assets/images/over-speed-icon.svg'
      }
    ];
  }

  transformMapEvents(rawEvents: RawEvent[]): MapEvent[] {
    const now = Date.now();
    const result: MapEvent[] = [];

    rawEvents.forEach(re => {
      re.coordinatesArray.forEach(coord => {
        result.push({
          lat: coord.coordinates[0],
          lng: coord.coordinates[1],
          ts: now, // if no timestamp is available, use current time
          type: re.alertName,
          label: `${re.alertName} (${coord.speed ?? 0} km/h in ${coord.speedLimit ?? 0} zone)`,
          icon: re.icon,
          alertName: re.alertName ?? 'Speed Violation',
          speed: coord.speed ?? 0,
          speedLimit: coord.speedLimit ?? 0
        });
      });
    });

    return result;
  }

  /**
   * Sets traffic signal coodinates array
   * @returns traffic signal coodinates array 
   */
  private _setTrafficSignalCoodinatesArray(): [number, number][] {
    const uniqueSegments = new Map<string, boolean>();
    const trafficSignalCoordinates: any = [];
    if (!this.transformedAttributeData || !Array.isArray(this.transformedAttributeData)) {
      return [];
    }
    const data = this.transformedAttributeData;
    for (const item of data) {
      const enhancedMap = item.enhancedMap;
      const trafficSignData = enhancedMap?.trafficSignData;
      const hasValidTrafficSignal =
        trafficSignData &&
        trafficSignData.length > 0 &&
        trafficSignData?.find(item => item?.conditionType?.toLowerCase() === 'signal');
      const segmentId = enhancedMap?.segmentId;

      if (hasValidTrafficSignal && segmentId && !uniqueSegments.has(segmentId)) {
        uniqueSegments.set(segmentId, true);
        const coords = enhancedMap.mappedCoordinates;
        if (coords) {
          trafficSignalCoordinates.push({ lat: coords.latitude, lng: coords.longitude });
        }
      }
    }
    return trafficSignalCoordinates;
  }

  setTunnelBridgeData() {
    const uniqueSegments = new Map<string, boolean>();
    const tunnelCoordinates: any = [];
    const bridgeCoordinates: any = [];
    if (!this.transformedAttributeData || !Array.isArray(this.transformedAttributeData)) {
      this.tunnelBridgeData = { tunnelData: [], bridgeData: [] };
    }
    const data = this.transformedAttributeData;
    for (const item of data) {
      const enhancedMap = item.enhancedMap;
      const tunnelData = enhancedMap?.roadGeometry?.isTunnel;
      const bridgeData = enhancedMap?.roadGeometry?.isBridge;
      const segmentId = enhancedMap?.segmentId;

      if (tunnelData && segmentId && !uniqueSegments.has(segmentId)) {
        uniqueSegments.set(segmentId, true);
        const coords = enhancedMap.mappedCoordinates;
        if (coords) {
          tunnelCoordinates.push({ lat: coords.latitude, lng: coords.longitude });
        }
      }
      if (bridgeData && segmentId && !uniqueSegments.has(segmentId)) {
        uniqueSegments.set(segmentId, true);
        const coords = enhancedMap.mappedCoordinates;
        if (coords) {
          bridgeCoordinates.push({ lat: coords.latitude, lng: coords.longitude });
        }
      }
    }
    this.tunnelBridgeData = { tunnelData: tunnelCoordinates, bridgeData: bridgeCoordinates };
  }

  groupBySegmentWithCoords(data: TelemetryItem[]) {
    const segmentMap = new Map<
      string,
      {
        latestItem: TelemetryItem;
        firstCoordinate: number[];
        lastCoordinate: number[];
      }
    >();

    data.forEach(item => {
      const segmentId = item.enhancedMap.segmentId;
      const timestamp = new Date(item.sourceTimestamp).getTime();

      const existing = segmentMap.get(segmentId);

      if (!existing) {
        segmentMap.set(segmentId, {
          latestItem: { ...item },
          firstCoordinate: [...item.coordinates],
          lastCoordinate: [...item.coordinates]
        });
      } else {
        const existingTime = new Date(existing.latestItem.sourceTimestamp).getTime();

        segmentMap.set(segmentId, {
          latestItem: timestamp > existingTime ? { ...item } : existing.latestItem,
          firstCoordinate: existing.firstCoordinate,
          lastCoordinate: [...item.coordinates]
        });
      }
    });

    return Array.from(segmentMap.entries()).map(([segmentId, value]) => ({
      segmentId,
      latestSourceTimestamp: value.latestItem.sourceTimestamp,
      enhancedMap: { ...value.latestItem.enhancedMap },
      firstCoordinate: [...value.firstCoordinate],
      lastCoordinate: [...value.lastCoordinate]
    }));
  }

  /**
   * Gets entities details (To fetch category specific tenant config)
   */
  private _getEntitiesDetails() {
    const entityId = { entityId: this.entityId };
    this._getEntityDetailsSubscription = this.sharedService.getEntityDetails(entityId).subscribe((result: any) => {
      if (result.status) {
        this.entityDetails = result?.response?.data[0];
        this._categoryTenantConfig = this.sharedService.getConfigurationBasedOnCategory(this.entityDetails) ?? {};
        this.chartTypes = this._categoryTenantConfig?.geoPlayBackCharts ?? [];
        this._getAlertData();
      } else {
        this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }


  /**
   * Gets telemetry coordinates
   */
  getTelemetryCoordinates() {
    this.isloader = true;
    this.loaderHandler.enableManualLoader();
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if (this.selectedDate) {
        startTime = this.selectedDate?.['start'];
        endTime = this.selectedDate?.['end'];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    //For chart
    this.chartSelectedDate = [new Date(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime)), new Date(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime))];
    const requestData = {
      siteId: this.sharedService.getSiteId(),
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      limit: 10000,
      entityIds: [this.entityId],
      tripEnhancements: {
        roadAttributes: this.includeAttributes
      }
    };
    this._activeEntityDetailsSubscription = this.sharedService.activeEntityDetailsV2(requestData, 1, false)
      .subscribe({
        next: (result: any) => {
          if (result['status']) {
            if (result['response']['data']?.length) {
              this.loaderHandler.toggleLoader(0);
              let transformedCurrentData = [];
              [...result['response']['data']].forEach((item: any) => {
                const transformedCurrentObj = {
                  ...item,
                  ...this.sharedService.flattenObject(item, 'vitals')
                };
                transformedCurrentData.push(transformedCurrentObj);
              });
              this.transformedAttributeData = transformedCurrentData;
              this.transformedAttributeData?.map((elem: any) => {
                elem['time'] = this.sharedService.getLastSeenFormat(elem.sourceTimestamp);
                if (!elem['attrValid']) {
                  elem['attrValid'] = false;
                }
                elem.attributes?.forEach((item: any) => {
                  if (item?.attributeName === 'RUL_BRAKE_PAD' || item?.attributeName === 'RUL_CLUTCH_PAD') {
                    elem[item.attributeName + '_Time'] = item.processedTime;
                  }
                });
              });
              const coordArray = this.transformedAttributeData?.map((data: any) => [
                data?.lat,
                data?.long,
                data?.sourceTimestamp
              ]);
              this.telemetryCoordinatesArray = coordArray?.map(([lat, lng, ts]) => ({ lat, lng, ts: Date.parse(ts) }));
              const hereCoordArray = this.toPlaybackPoints(this.transformedAttributeData);
              this.hereMappedCoordinatesArray = hereCoordArray;
              if (this.index === 0) {
                this.masterMapData = [
                  {
                    polygonData: coordArray,
                    currentCoordinate: coordArray?.[0],
                    upcomingCoordinate: coordArray?.[1]
                  },
                ];
                this.totalSteps = this.masterMapData?.[0]?.polygonData?.length || 0;
                this.telemetryTableData = this.transformedAttributeData?.slice(0, 2);
                for (let index = 0; index < this.telemetryTableData?.length; index++) {
                  if (index === 0) {
                    this.telemetryTableData[index] = { ...this.telemetryTableData[index], current: true }
                  }
                }
                this.telemetryTableData.unshift({});
              }
              transformedCurrentData = [];
              this.telemetryAlertCoordinates = this._fetchAlertCoordinates();
              if (result['response']['pageInfo']) {
                this.pager = { ...result['response']['pageInfo'] };
              }
            } else {
              this.transformedAttributeData = [];
              this.totalPages = [];
              if (result?.response?.message)
                this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
            }
          }
          else {
            this.loaderHandler.toggleLoader(0);
            this.transformedAttributeData = [];
            if (result?.response?.message)
              this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
          }
          this.isloader = false;
          this.loaderHandler.disableManualLoader();
        }, error: (error) => {
          if (error) {
            this.transformedAttributeData = [];
            this.isloader = false;
            this.loaderHandler.disableManualLoader();
          }
        }
      });

  }

  toPlaybackPoints(data: any[]): any[] {
    if (!Array.isArray(data)) return [];

    return data
      .map((item) => {
        const mapped = item?.enhancedMap?.mappedCoordinates;
        const tsRaw = item?.sourceTimestamp;

        if (!mapped || !tsRaw) return null;

        const ts = Date.parse(tsRaw);
        if (Number.isNaN(ts)) return null;

        return {
          lat: Number(mapped.latitude),
          lng: Number(mapped.longitude),
          ts
        };
      })
      .filter((p): p is any => p !== null);
  }

  /**
   * Gets trip details (To fetch locations)
   */
  private _getTripDetails() {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if (this.selectedDate) {
        startTime = this.selectedDate?.['start'];
        endTime = this.selectedDate?.['end'];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    const _reqPayload = {
      entityId: this.entityId,
      siteId: this.sharedService.getSiteId(),
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._getTripDetailsSubscription = this._service
      .getEntitySummary(_reqPayload)
      .subscribe({
        next: (result: any) => {
          this.geotraceDetails = result;
        },
        error: () => {
          this.geotraceDetails = {};
        },
      });
  }

  /**
   * Gets alert data
   */
  private _getAlertData() {
    let configStartDate = null;
    let configEndDate = null;
    this._tenantConfig = this.sharedService?.getConfiguration('tenantGenericConfig') ? this.sharedService?.getConfiguration('tenantGenericConfig') : null;

    if (this._tenantConfig?.defaultTimeRange) {
      const configHour = this._tenantConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let startTime;
    let endTime;
    if (this._tenantConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      if (this.selectedDate) {
        startTime = this.selectedDate?.['start'];
        endTime = this.selectedDate?.['end'];
      } else {
        [startTime, endTime] = this._generalService?.getStartEndTimeByDate();
      }
    } else {
      [startTime, endTime] = this.selectedDate ? this._generalService?.getStartEndTimeForSelectedDate(this.selectedDate, this._tenantConfig?.tenant, this._tenantConfig?.defaultTimeRange) : this._generalService?.getStartEndTimeByDate();
    }
    //For Chart
    this.chartSelectedDate = [new Date(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime)), new Date(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime))];
    this.chartType?.setValue(this.chartTypes?.[0]?.value);
    this.chartAttributes = {
      chartAttributes: { ...this.chartTypes?.[0]?.value, ...{ entityNames: [{ _id: this.entityId, uniqueId: this.entityDetails?.uniqueId }] } }, selectedDates: {
        from: this.chartSelectedDate?.[0],
        to: this.chartSelectedDate?.[1]
      }
    }
    const reqData = {
      filterBy: "Alert",
      classType: "Alert",
      page: 1,
      autoClose: false,
      filterList: [],
      entityId: this.entityId,
      zoneId: null,
      from: this._datePipe.transform(this.aggregateDate?.from ?? ((!this.selectedDate && configStartDate) ? configStartDate : startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.aggregateDate?.to ?? ((!this.selectedDate && configEndDate) ? configEndDate : endTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService.getSiteId(),
      entityCategory: this.sharedService.getConfiguration('tenantCategory') ? this.sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
      limit: 10000
    };
    this._alertListSubscription = this.sharedService.alertList(reqData).subscribe((result: any) => {
      if (result['status']) {
        if (result['response'].length) {
          this.alertData = [...result['response']];
          this.alertData.map((item: any) => {
            item.originalTime = item.time;
            item.time = this.sharedService.getLastSeenFormat(item?.time);
            item.acknowledged = item.status === true ? 'Active' : ((item.status === false && !item.state) ? 'Acknowledged' : 'Invalid');
            item.status = item.status === true ? 'Active' : 'Acknowledged';
            item.ackBy = item.ackBy ? item.ackBy : "--";
            item.ackTime = item.ackTime !== 'null' ? this.sharedService.getLastSeenFormat(item?.ackTime) : "--";
            item.vehicle = "KL01BX-- -- --";
            item.entityType = 'alerts';
            item.entityModule = this._setEntityType(item.entityCategory);
            item.destination = item.destination ? item.destination : '--';
            item.attributeValue = item.attributeValue ? '' + item.attributeValue : "--";
          });
          this.alertsHighlighted = [...this.alertData];
        }
        else {
          this.alertData = [];
        }
        if (result['pageInfo']) {
          this.pager = { ...result['pageInfo'] };
        }
      } else {
        this.alertData = [];
        this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
 * Sets entity type
 * @param category 
 * @returns  
 */
  private _setEntityType(category: any) {
    const filteredEntityEntityModule = this._entitiesMarkerList.find((entity: any) => entity.entityCategory === category);
    return filteredEntityEntityModule ? this._setRoute(+filteredEntityEntityModule.entityModule) : '';
  }

  /**
   * Sets route
   * @param entityModule 
   * @returns  
   */
  private _setRoute(entityModule: number) {
    switch (entityModule) {
      case 1: return 'vehicles';
      case 2: return 'assets';
      case 3: return 'people';
      default: return 'assets';
    }
  }
}